import * as tslib_1 from "tslib";
import Icon from '../Icon';
import styled, { withProps } from '../styles';
var DirectionIcon = withProps()(styled(Icon))(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  font-size: 16px;\n  transition: ", ";\n  opacity: ", ";\n  margin: 0 4px;\n  user-select: none;\n  transform: rotateZ(", "deg);\n  color: currentColor;\n"], ["\n  font-size: 16px;\n  transition: ",
    ";\n  opacity: ", ";\n  margin: 0 4px;\n  user-select: none;\n  transform: rotateZ(", "deg);\n  color: currentColor;\n"])), function (props) {
    return props.theme.transitions.create(['opacity', 'transform'], {
        duration: props.theme.transitions.duration.shortest,
    });
}, function (props) { return (props.active ? 1 : 0); }, function (props) { return (props.direction === 'asc' ? 180 : 0); });
export default DirectionIcon;
var templateObject_1;
//# sourceMappingURL=DirectionIcon.js.map